import { useEffect, useState } from "react";
import {
   Card,
   Typography,
   Button,
   Table,
   Space,
   Tag,
   Popconfirm,
   message
} from "antd";
import {
   PlusOutlined,
   EditOutlined,
   DeleteOutlined
} from "@ant-design/icons";

import {
   getSalesTargets,
   deleteSalesTarget
} from "../../services/salesTargetService";
import SalesTargetModal from "./SalesTargetModal";

const { Title, Text } = Typography;

const SalesTarget = () => {

   const [loading, setLoading] = useState(false);
   const [targets, setTargets] = useState([]);
   const [openModal, setOpenModal] = useState(false);
   const [editData, setEditData] = useState(null);

   const fetchTargets = async () => {
      try {

         setLoading(true);

         const data = await getSalesTargets();

         setTargets(data);

      } catch (err) {

         message.error(err.message || "Failed to load targets");

      } finally {

         setLoading(false);

      }
   };

   useEffect(() => {
      fetchTargets();
   }, []);

   const handleDelete = async (id) => {

      try {

         await deleteSalesTarget(id);

         message.success("Target deleted successfully.");

         fetchTargets();

      } catch (err) {

         message.error(err.message || "Delete failed");

      }

   };

   const columns = [
      {
         title: "#",
         render: (_, __, index) => index + 1,
         width: 60
      },
      {
         title: "Sales Person",
         dataIndex: "sales_person"
      },
      {
         title: "Start Date",
         dataIndex: "start_date",
         render: (date) => new Date(date).toLocaleDateString()
      },
      {
         title: "End Date",
         dataIndex: "end_date",
         render: (date) => new Date(date).toLocaleDateString()
      },
      {
         title: "Target",
         dataIndex: "target_amount"
      },
      {
         title: "Commission",
         dataIndex: "commission_amount"
      },
      {
         title: "Status",
         dataIndex: "status",
         render: (status) => (
            <Tag color={status === "active" ? "green" : "red"}>
               {status}
            </Tag>
         )
      },
      {
         title: "Action",
         render: (_, record) => (
            <Space>

               <Button
                  type="text"
                  icon={<EditOutlined />}
                  onClick={() => {
                     setEditData(record);
                     setOpenModal(true);
                  }}
               />

               <Popconfirm
                  title="Delete Target?"
                  onConfirm={() => handleDelete(record.id)}
               >
                  <Button
                     danger
                     icon={<DeleteOutlined />}
                     type="text"
                  />
               </Popconfirm>

            </Space>
         )
      }
   ];

   return (<>



      <Card>

         <Space
            style={{
               width: "100%",
               justifyContent: "space-between",
               marginBottom: 20
            }}
         >

            <div>

               <Title level={3}>
                  Sales Targets
               </Title>

               <Text type="secondary">
                  Manage sales targets and commissions.
               </Text>

            </div>

            <Button
               type="primary"
               icon={<PlusOutlined />}
               onClick={() => {
                  setEditData(null);
                  setOpenModal(true);
               }}
            >
               Add Target
            </Button>

         </Space>

         <Table
            rowKey="id"
            loading={loading}
            columns={columns}
            dataSource={targets}
            pagination={{
               pageSize: 10
            }}
         />

      </Card>

      <SalesTargetModal
         open={openModal}
         editData={editData}
         onCancel={() => {
            setOpenModal(false);
            setEditData(null);
         }}
         onSuccess={() => {
            setOpenModal(false);
            setEditData(null);
            fetchTargets();
         }}
      />
   </>

   );

};

export default SalesTarget;